import Verticals from '@sunbit-dev/common/enums/Verticals';
import { VerticalGroup } from '../enums/VerticalGroup';

export const getVerticalGroupByVertical = (vertical: Verticals): VerticalGroup => {
  switch (vertical) {
    case Verticals.Eyewear:
    case Verticals.Dental:
    case Verticals.Veterinary:
    case Verticals.Med_Spa:
    case Verticals.Medical_Office:
    case Verticals.Hospital_Health_System:
    case Verticals.Health_and_Beauty:
    case Verticals.Medical_Devices:
    case Verticals.Eye_Technology:
      return VerticalGroup.Healthcare;
    default:
      return VerticalGroup.Default;
  }
};

export const isHealthcareVertical = (vertical: keyof typeof Verticals): boolean => {
  return getVerticalGroupByVertical(Verticals[vertical]) === VerticalGroup.Healthcare;
}
